import React, { Component } from 'react';
import '../css/App.css';


class AssignedModulesChild1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }
    componentWillMount() {

    }

    render() {
console.log(this.props)
if(!this.props.squential){
    if(this.props.alwaysOpen){
    return (

        <div className="unit_assign col-sm-12 col-xs-12">
             <div className="col-sm-1 col-xs-1 pad_z "><i  onClick={() => this.props.makeStar()} style={{color:this.props.stared === '0' ? "":"orange" }} className="material-icons">
                star_border
</i></div>
            <div className="col-sm-10 col-xs-10 pad_z topic"  onClick={() => this.props.starUnit()}>{this.props.ChildComponent1content}</div>
            <div className="col-sm-1 col-xs-1 pad_z"  onClick={() => this.props.starUnit()}><i className="material-icons">
                keyboard_arrow_right
</i></div>
{this.props.greenDot &&  <i className="material-icons completed1" style={{background:this.props.greenDot}}>
                                        done
                                        </i>}
        </div>
        
    );
    }else{
   if(this.props.PreCompleted.completed){
    return (

        <div className="unit_assign col-sm-12">
             <div className="col-sm-1 col-xs-1 pad_z "><i  onClick={() => this.props.makeStar()} style={{color:this.props.stared === '0' ? "":"orange" }} className="material-icons">
                star_border
</i></div>
            <div className="col-sm-10 col-xs-10 pad_z topic" style={{display:'flex'}}  onClick={() => this.props.starUnit()}>{this.props.ChildComponent1content}</div>
            <div className="col-sm-1 col-xs-1 pad_z"  onClick={() => this.props.starUnit()}><i className="material-icons">
                keyboard_arrow_right
</i></div>
{this.props.greenDot &&  <i className="material-icons completed1" style={{background:this.props.greenDot}}>
                                        done
                                        </i>}
        </div>
        
    );
   }else{
        return (

            <div className="unit_assign col-sm-12" >
                 <div className="col-sm-1 col-xs-1 pad_z "><i  onClick={() => this.props.makeStar()} style={{color:this.props.stared === '0' ? "":"orange" }} className="material-icons">
                star_border
</i></div>
                <div className="col-sm-10 col-xs-10 pad_z topic"  onClick={() => this.props.starUnit()}>{this.props.ChildComponent1content}</div>
                <div className="col-sm-1 col-xs-1 pad_z"  onClick={() => this.props.starUnit()}><i className="material-icons">
                    keyboard_arrow_right
    </i></div>
    {this.props.greenDot &&  <i className="material-icons completed1" style={{background:this.props.greenDot}}>
                                            done
                                            </i>}
                                            <i className="material-icons completed2" style={{color:"grey"}}>
                                            lock
                                            </i>                              
            </div>
            
        );
   }

    }
}else{
        return (

            <div className="unit_assign col-sm-12">
                 <div className="col-sm-1 col-xs-1 pad_z "><i  onClick={() => this.props.makeStar()} style={{color:this.props.stared === '0' ? "":"orange" }} className="material-icons">
                star_border
</i></div>
                <div className="col-sm-11 col-xs-11 pad_z topic"  onClick={() => this.props.starUnit()}>{this.props.ChildComponent1content}</div>
                <div className="col-sm-1 col-xs-1 pad_z"  onClick={() => this.props.starUnit()}><i className="material-icons">
                    keyboard_arrow_right
</i></div>
{this.props.greenDot &&  <i className="material-icons completed1" style={{background:this.props.greenDot}}>
                                            done
                                            </i>}
            </div>
            
        );
}
    }
}

export default AssignedModulesChild1;